import React, { useState, useEffect, } from 'react'
import { Link } from 'react-router-dom';
import { Table, Button, Space, Alert, message, Typography, Row, Form, Input, Pagination } from 'antd';
import { DeleteOutlined, EditOutlined, WarningFilled} from '@ant-design/icons';
import { Modal } from '../../UI/Modal/Modal.component';

const { Text, Paragraph } = Typography;

export const PromotionTable = ({data, branches, search, setPagination, pagination, ...props}) => {

    const [dataSource, setDataSource] = useState(data.rows);
    // const [branches, setBranches] = useState();
    const [totalRecords, setTotalRecords] = useState(data.count);
    const [filteredResults, setFilteredResults] = useState('');
    const [currentRow, setCurrentRow] = useState('');
    const [displayModal, setDisplayModal] = useState(false);  

    useEffect(() => {
        setDataSource(data.rows);
        setTotalRecords(data.count)
    }, [data])


    const onShowSizeChange = (current, pageSize) => {
        const change = {
            current: current, 
            pageSize: pageSize,
        };        
        setPagination(change);
    };

    const onChange = (page, pageSize) => {
        const change = {
            current: page, 
            pageSize: pageSize,
        };
        window.scrollTo(0,0);
        setPagination(change);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 50,
        },
        {
            title: 'Promocion',
            dataIndex: 'promocion',
            fixed: 'left',
            width: 200,
        },
        {
            title: 'Descripción',
            dataIndex: 'descripcion',
            width: 400,
        },
        {
            title: 'Sucursal',
            dataIndex: 'id_sucursal',
            width: 200,
            render: (record) => branches.find(branch => branch.id === record).sucursal
        },
        {
            title: 'Estatus',
            dataIndex: 'estatus',
            width: 200,
        },
        {
            title: 'Cantidad Min. Canje',
            dataIndex: 'cant_min_canje',
            width: 130,
        },
        {   
            title: 'Opción',
            key: 'id',
            width: 250,
            render: (_, record) => {
                return (
                    <>
                        <Space size="middle">
                            <Link to={"../promocion/editar/" + record.id}><Button size='small'>Editar</Button></Link>
                        </Space>
                    </>
                );
            },
        }
        

    ];


    const showTotalMessage = (total, range) => {
        
        let defaultMessage = `Mostrando ${range[0]}-${range[1]} de ${total} registros`;
        let filteredMessage = `${defaultMessage} que contienen "${search}". Resultados filtrados:  ${dataSource.length} registro.`;

        return search ? filteredMessage : defaultMessage;
    }
    
    return (
        <>
            <Table
                size="small"
                columns = {columns}
                dataSource = {dataSource}
                rowKey = 'id'
                scroll={{
                    x: "1000",
                }}
                tableLayout="auto"
                pagination= {false}
            >
            </Table>

            {pagination ? 
                <Row justify="end" style={{marginTop: 20}}>
                    <Pagination 
                        total={totalRecords}
                        defaultCurrent={pagination.current}
                        defaultPageSize={pagination.pageSize}
                        showSizeChanger
                        showQuickJumper
                        showTotal = {(total, range) => showTotalMessage(total, range)}
                        onChange={(page, pageSize) => onChange(page, pageSize)}
                    />
                </Row> 
            : ''}
            
        </>
    );
}